import dayjs from 'dayjs';
import { PREFERRED_RATE_MIN_DAYS_BETWEEN_EDITING } from 'lumen/utils/constants/pricing-assistant-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function timeUntilNextAllowedUpdate(lastEdited: string) {
  return dayjs(lastEdited)
    .add(PREFERRED_RATE_MIN_DAYS_BETWEEN_EDITING, 'day')
    .fromNow();
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isMinDaysBetweenEditingElapsed(lastEdited: string) {
  const daysSinceLastUpdated = dayjs.utc().diff(dayjs(lastEdited), 'day');
  return daysSinceLastUpdated >= PREFERRED_RATE_MIN_DAYS_BETWEEN_EDITING;
}
